
export class LOVConventionRegistrationTypeExtension {
}
